// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"ba22d441","119":"ba22d441","213":"ba22d441","383":"b16d1df2","496":"ba22d441"}[chunkId] + ".chunk.css";
};